export default __webpack_public_path__ + "static/media/award-solid.fd45eb92.svg";